import { render, staticRenderFns } from "./cover-image.vue?vue&type=template&id=2e302b52"
import script from "./cover-image.vue?vue&type=script&lang=js"
export * from "./cover-image.vue?vue&type=script&lang=js"
import style0 from "./cover-image.vue?vue&type=style&index=0&id=2e302b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports